module.exports = __webpack_public_path__ + "static/media/Classic Country Hollow VR.c7ee26c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Classic Country Hollow VR.mp3
// module id = SsyH
// module chunks = 12